/* esm.sh - applesauce-signers@5.2.0/signers/password-signer */
export * from "/*applesauce-signers@5.2.0/esnext/signers/password-signer.mjs";
